module.exports = __webpack_public_path__ + "img/product_8.960b093.svg";